import angular from 'angular';
import sumBy from 'lodash/sumBy';
import isEmpty from 'lodash/isEmpty';
import s from './step1Ctrl.module.css';
import { getProductAliasFromType } from '../../lib/productHelpers';
import {
  toggleItemsDisclaimerChecked,
  getRedirectUrlPath,
  receivePendingCancelReturnId,
  updateStep2Complete,
  setLoading,
} from '../../actions/page';
import getPrinterlessInfoLink from '../../lib/getPrinterlessInfoLink';
import cancelLabel from '../../lib/cancelLabel';
import generateMethodKey from '../../lib/generateMethodKey';
import { fetchStoreLocations, resetSelectedLocation } from '../../actions/storeLocator';
import {
  fetchConsolidatedMethods,
  fetchReturnMethods,
  resetReturnMethod,
  selectReturnMethod,
} from '../../actions/returnMethods';
import { setReturnItems } from '../../actions/returnItems';
import {
  MAIL,
  KEEP_THE_ITEM,
  PRINTERLESS_METHODS,
  METHODS_WITHOUT_PSSLS,
} from '../../constants/returnMethods';
import DEFAULT_COPY from '../../constants/defaultCopy';
import { RETURN_OPTIONS_THAT_REQUIRE_LOCATIONS } from '../../constants/storeLocator';
import { RECEIVE_RETURN_ORDER } from '../../actions/orderInfo';
import { addMultiOrderItem } from '../../actions/multiOrders';
import { urlParam } from '../../lib/url';
import {
  getInitiatedReturnsHeader,
  isNotShipped,
} from '../../react-components/PendingReturns/utils';
import {
  displayEligibilityMessage,
  getIneligibleMsg,
  getItemEligibilityMsg,
  getIneligibleQtyPath,
} from '../../services/return-items-service/utils';
import { bypassStep, selectMethod, selectOption } from '../../actions/returnOptions';
import { toggleTooltip } from '../../actions/tooltip';
import {
  refreshOrder,
  templateStrings,
  triggerCancelReturnErrorTooltip,
  triggerIneligibilityTooltip,
  updateSubmitStatus,
} from './helpers';
import { store } from '../../store';
import { setItemReturnQtyByDay } from '../../actions/orderService';
import {
  setBlindItemsEnabled,
  setCancellingLabel,
  setShowDisabledBtnErrorMsg,
  setTooltipText,
} from '../../actions/itemsPage';
import {
  blindReturnSidebarService,
  blindRepairSidebar,
  postReturnService,
  returnItemsService,
  orderService,
  retailerSettingsService,
  returnMethodSidebar,
  returnReasonSidebar,
  repairSidebar,
  exchangeSidebar,
} from '../../services';
import { RECEIVE_CLAIMS_SIDEBAR_INIT } from '../../actions/claims';
import { renderProductSelectionSidebar } from '../../react-components/ProductSelectionSidebar';
import { ActionTypes } from '../../constants/enums';

angular.module('Step1Ctrl', []).controller('Step1Controller', [
  '$route',
  '$scope',
  '$rootScope',
  '$location',
  ($route, $scope, $rootScope, $location) => {
    const {
      claims: { enabled: claimsEnabled } = {},
      restrictions: { maxItemsReached },
      page: {
        languageCode,
        productType,
        browserFingerprint,
        locale,
        secureMode,
        deferOverride,
        overrideCode,
      } = {},
      retailerSettings: { name: retailer } = {},
      returnsSettings: {
        [productType]: {
          returnOptions: { enabled: returnOptionsEnabled, availableOptionsApi } = {},
          enableDisabledBtnError = false,
          showInitiatedReturnsTrackingNumber = false,
          exchange: { unevenExchanges } = {},
        } = {},
      } = {},
      multiOrders: { orders: additionalOrders = [] } = {},
      language,
    } = store.getState();

    $scope.state = store.getState();

    const updateStoreState = () => {
      $scope.state = store.getState();
    };

    updateStoreState();
    const unsubscribeFromReduxUpdates = store.subscribe(updateStoreState);
    $scope.$on('$destroy', unsubscribeFromReduxUpdates);

    const { [languageCode]: DEFAULT_LANG_COPY = {} } = DEFAULT_COPY;
    $scope.s = s;
    const isMultiOrder = retailerSettingsService.getIsMultiOrder();
    const isExchange = retailerSettingsService.getIsExchangeEnabled();
    $rootScope.pageClass = 'step1-page';
    $scope.style = retailerSettingsService.getStyle();

    store.dispatch(setShowDisabledBtnErrorMsg(false));
    $scope.showInitiatedReturnsTrackingNumber = showInitiatedReturnsTrackingNumber;

    if (!orderService.getOrder().order_info) {
      $location.path(store.dispatch(getRedirectUrlPath()));
    }

    if (returnMethodSidebar.isSidebarOpen()) {
      returnMethodSidebar.closeSidebar();
    }

    $scope.isNotEmptyLabel = (label) => label.return_items && label.return_items.length > 0;

    store.dispatch(
      setBlindItemsEnabled(
        retailerSettingsService.getSettings().blindReturnConfig ||
        retailerSettingsService.getSettings().blindRepairsConfig,
      ),
    );
    store.dispatch(setCancellingLabel(false));
    $scope.disableItemCancel = retailerSettingsService.getItemCancelDisabled();
    store.dispatch(setTooltipText(''));
    $scope.multiOrderEnabled = urlParam({ param: 'multiOrder' });

    $scope.updateAdditionalOrders = () => {
      $route.reload();
    };

    $scope.getItemEligibilityMsg = (item) => getItemEligibilityMsg(item);
    $scope.displayItemEligibilityMsg = (item) => displayEligibilityMessage(item);
    $scope.getIneligibleMsg = (item) => getIneligibleMsg(item);
    $scope.getIneligibleQtyPath = (item) => getIneligibleQtyPath(item);

    const returnStatus = () => {
      const { page: { allStepsComplete } = {} } = store.getState();

      if (allStepsComplete) {
        $location.path(store.dispatch(getRedirectUrlPath()));
      }
    };

    if (orderService.getOrder().order_info) {
      window.setTimeout(() => {
        templateStrings();
      }, 500);
    }

    const checkMaxItemsReached = () => {
      if (maxItemsReached) {
        $scope.itemSidebar({ item: returnItemsService.getItems()[0] });
      }
    };

    const checkCount = () => {
      const itemCount = returnItemsService.getItems().length;
      if (itemCount === 0) {
        $rootScope.isDisabled = true;
      } else {
        $rootScope.isDisabled = false;
      }
    };

    $scope.removeItem = (item, $event) => {
      $event.stopPropagation();
      item.return_desc = '';
      returnItemsService.removeItem(item);
      item.selected = false;
      checkCount();
    };

    $scope.cancelLabel = async (label, event) => {
      if (event) {
        event.preventDefault();
      }

      const order = isMultiOrder
        ? orderService.getOrder().customer_info.customer_ref_number
        : orderService.getOrder().order_info.order_number;
      const returnLabel = { ...label, retailer, order };

      const cancelLabelState = orderService.getLabels().reduce((foundLabel, nextLabel) => {
        if (returnLabel.tracking_number === nextLabel.tracking_number && foundLabel === false) {
          return returnLabel.tracking_number;
        }
        return foundLabel;
      }, false);

      store.dispatch(setCancellingLabel(cancelLabelState));

      const successfullyCancelledLabel = await cancelLabel(browserFingerprint)(returnLabel);

      if (successfullyCancelledLabel) {
        refreshOrder();
      } else {
        const cancelReturnErrorMsg = language['returns.step_1.cancel_return_error_tooltip'];

        triggerCancelReturnErrorTooltip(cancelReturnErrorMsg);
      }

      store.dispatch(setCancellingLabel(false));
    };

    $scope.openCancelModal = (label, event) => {
      event.preventDefault();
      store.dispatch(receivePendingCancelReturnId(label.return_id));
    };

    $scope.giftOrder = {};

    const stepTwo = () => {
      returnReasonSidebar.actions.toggle();
      store.dispatch(setReturnItems(returnItemsService.getItems()));
      returnItemsService.updateCartActions();
      $location.path(store.dispatch(getRedirectUrlPath('step-2')));
    };

    const getStep2ConciergeLocations = () =>
      new Promise((resolve) => {
        setTimeout(() => {
          const {
            returnOptions: { returnOptions = [], returnOptionMethods = {} },
            storeLocator: { cachedQueries = {}, postalCode = '' },
          } = store.getState();

          const returnOptionMethodVisibility = Object.keys(returnOptionMethods).filter((option) => {
            const { [option]: { [postalCode]: cachedLocations = [] } = {} } = cachedQueries;
            const { id, disable_locations_requirement: disableLocationsRequirement } =
              returnOptionMethods[option];

            if (
              RETURN_OPTIONS_THAT_REQUIRE_LOCATIONS.includes(id) &&
              !disableLocationsRequirement
            ) {
              return cachedLocations.length > 0;
            }

            return true;
          });

          const returnOptionVisibility = returnOptions.filter(({ id, methods }) => {
            if (RETURN_OPTIONS_THAT_REQUIRE_LOCATIONS.includes(id)) {
              const methodKeys = methods.map(generateMethodKey);
              return methodKeys.some((key) => returnOptionMethodVisibility.includes(key));
            }
            return true;
          });

          store.dispatch({
            type: 'RETURN_OPTION_VISIBILITY',
            data: { returnOptionVisibility },
          });

          resolve();
        }, 0);
      });

    // Add items and go to step 2
    const nextStep = (giftOrder) => {
      const { tooltip } = store.getState();
      store.dispatch(setLoading(true));
      Object.keys(tooltip).forEach((key) => {
        if (tooltip[key]) {
          store.dispatch(toggleTooltip(key));
        }
      });
      returnItemsService.putGift(giftOrder);
      const order = returnItemsService.getReturnOrder();
      if (order.return_items) {
        order.return_items = order.return_items.map((item) => {
          const newItem = { ...item };
          delete newItem.return_reason_codes;
          return newItem;
        });
      }
      store.dispatch({
        type: RECEIVE_RETURN_ORDER,
        data: {
          returnOrder: order,
        },
      });

      if ((returnOptionsEnabled && availableOptionsApi !== false) || (retailerSettingsService.getIsSimpleReturnsEnhanced())) {
        store
          .dispatch(
            fetchConsolidatedMethods({
              returnOrder: order,
            }),
          )
          .then(
            ({
              no_location_based_pudo_options: noLocationBasedPudoOptions = [],
              display_available_options: displayAvailableOptions = true,
            } = {}) => {
              const methods = noLocationBasedPudoOptions;
              if (displayAvailableOptions === false) {
                store.dispatch(resetSelectedLocation());
                store.dispatch(resetReturnMethod());
              }
              if (methods.length < 2 && displayAvailableOptions === false) {
                if (methods.length === 0) {
                  store.dispatch(updateStep2Complete(true));
                  store.dispatch(bypassStep(['methods']));
                  $location.path(store.dispatch(getRedirectUrlPath('step-3')));
                  return;
                }
                const methodKey = methods[0].return_method || methods[0].display_method;
                if (!methodKey) {
                  window.setTimeout(() => {
                    stepTwo();
                  }, 0);
                  return;
                }
                store.dispatch(updateStep2Complete(true));
                store.dispatch(selectOption(methodKey));
                store.dispatch(selectMethod(methodKey));
                store.dispatch(bypassStep(['methods']));
                $location.path(store.dispatch(getRedirectUrlPath('step-3')));
                return;
              }
              window.setTimeout(() => {
                stepTwo();
              }, 0);

            },
          );
      } else if (returnOptionsEnabled) {
        store.dispatch(fetchReturnMethods({ returnOrder: order })).then(() => {
          window.setTimeout(() => {
            store.dispatch(fetchStoreLocations()).then(() => {
              window.setTimeout(() => {
                getStep2ConciergeLocations().then(() => {
                  window.setTimeout(stepTwo, 0);
                });
              }, 0);
            });
          }, 0);
        });
      } else {
        store
          .dispatch(fetchReturnMethods({ returnOrder: order }))
          .then(() => window.setTimeout(stepTwo, 0));
      }
      return false;
    };

    $rootScope.giftDisabled = true;

    // Run check count
    checkCount();

    $scope.printLabel = (label, event) => {
      event.preventDefault();
      window.open(label.url, '_blank');
    };

    $scope.isNotShipped = (label) => isNotShipped({ label });

    $scope.showButtonTrack = (label) =>
      !$scope.isNotShipped(label) && label.return_method !== 'local_pickup' && !secureMode;

    $scope.showButtonReprintLabel = (label) =>
      $scope.hasReprintLabelLink(label.return_method) && label.pssl !== false && !secureMode;

    $scope.showButtonCancel = (label) =>
      !$scope.disableItemCancel && label.cancel_eligibility !== false;

    $scope.getInitiatedReturnsHeader = (label) => getInitiatedReturnsHeader({ label });

    $scope.displayReturnedActions = (label) => {
      const methodKey = generateMethodKey(label);
      return methodKey !== KEEP_THE_ITEM;
    };

    $scope.handleDisabledBtnClick = () => {
      if (enableDisabledBtnError) {
        store.dispatch(setShowDisabledBtnErrorMsg(true));
      }
    };

    $scope.returnCount = () => sumBy(returnItemsService.getItems(), 'qty');

    const getExchangeAttributes = (returnItem) =>
      Object.values(returnItem.selectedOptions).join(' - ');

    const itemSidebarUpdate = (returnItem, additionalItems, overrideToggleStatus) => {
      const { ineligibilityInfo } = returnItem;

      const { multiOrders: { orders: additionalOrders = [] } = {} } = store.getState();

      const itemUpdater = (item) => {
        let newItem = item;

        if (returnItem.item_id === newItem.item_id && returnItem.order_id === newItem.order_id) {
          newItem = returnItem;
          newItem.itemStatus = '';
          newItem.itemWarning = '';
          updateSubmitStatus();

          if (ineligibilityInfo) {
            triggerIneligibilityTooltip(newItem);
          } else {
            const reasonLabel = returnItem.return_desc;
            newItem.itemStatus = reasonLabel
              ? `${language['returns.item.reason_label'] || ''} ${reasonLabel}`
              : '';

            if (returnItem.product === getProductAliasFromType('exchange') && !unevenExchanges) {
              const exchangedForMsg = `${language['returns.item.exchange_label'] || ''
                } ${getExchangeAttributes(returnItem)}`;
              newItem.itemStatus = reasonLabel
                ? `${exchangedForMsg}; ${reasonLabel}`
                : exchangedForMsg;
            }

            if (returnItem.action_type === ActionTypes.Claim) {
              newItem.itemStatus = `${language['returns.item.claim_label']} ${reasonLabel}`;
            }
          }
        }

        return newItem;
      };

      const updatedItems = orderService.getItems().map(itemUpdater);

      if (additionalOrders.length > 0) {
        const updatedMultiOrderItem = itemUpdater(returnItem);
        store.dispatch(addMultiOrderItem(updatedMultiOrderItem));
      }

      orderService.updateItems(updatedItems);
      store.dispatch(setItemReturnQtyByDay(orderService.getReturnAndEligibleByDate(false)));
      $scope.$digest();

      if ((additionalItems && !overrideToggleStatus) || ineligibilityInfo) {
        returnReasonSidebar.actions.toggle();
      }

      if (!additionalItems && !ineligibilityInfo) {
        nextStep($scope.giftOrder);
      }
    };

    const updateBlindReturns = (additionalItem) => {
      let updatedItems = orderService.getItems();

      const order = returnItemsService.getReturnOrder();
      const blindItems = Object.values(blindReturnSidebarService.getBlindItems());
      updatedItems = updatedItems.filter(
        (item) => !item.blindItem || (item.blindItem && item.fulfillment_status),
      );
      orderService.updateItems([...blindItems, ...updatedItems]);
      blindReturnSidebarService.actions.toggle();
      blindReturnSidebarService.actions.resetForm();
      updateSubmitStatus();
      $scope.$digest();

      if (!additionalItem) {
        store.dispatch(setLoading(true));
        returnItemsService.putGift($scope.giftOrder);
        store.dispatch(fetchReturnMethods({ returnOrder: order })).then(stepTwo);
      }
    };

    const updateBlindRepairs = (items, additionalItem) => {
      let updatedItems = orderService.getItems();
      const order = returnItemsService.getReturnOrder();
      const blindItems = Object.values(items);
      updatedItems = updatedItems.filter(
        (item) => !item.blindItem || (item.blindItem && item.fulfillment_status),
      );

      blindRepairSidebar.actions.toggle();
      orderService.updateItems([...blindItems, ...updatedItems]);
      updateSubmitStatus();
      $scope.$digest();

      if (!additionalItem) {
        store.dispatch(setLoading(true));
        returnItemsService.putGift($scope.giftOrder);
        store.dispatch(fetchReturnMethods({ returnOrder: order })).then(stepTwo);
      }
    };

    const updateRepairSidebar = (repairItem, additionalItem) => {
      let updatedItems = orderService.getItems();
      updatedItems = updatedItems.map((item) => {
        let newItem = item;

        if (repairItem.item_id === newItem.item_id) {
          newItem = repairItem;
          newItem.itemStatus =
            newItem.selected && newItem.repairDescription
              ? `Repair: ${newItem.repairDescription}`
              : '';
          updateSubmitStatus();
        }

        return newItem;
      });

      orderService.updateItems(updatedItems);
      $scope.$digest();

      if (!additionalItem) {
        const order = returnItemsService.getReturnOrder();
        store.dispatch(setLoading(true));
        store.dispatch(fetchReturnMethods({ returnOrder: order })).then(stepTwo);
      }
    };

    const confirmReturnOrder = () => {
      store.dispatch(setLoading(true));
      const { tooltip } = store.getState();
      const returnPostTooltipState = tooltip.returnPostErrorTooltip;

      if (returnPostTooltipState) {
        store.dispatch(toggleTooltip('returnPostErrorTooltip'));
      }

      const order = retailerSettingsService.mergeObjects(
        returnItemsService.getReturnOrder(),
        orderService.storedOrder(),
      );

      postReturnService
        .submitReturn(order)
        .then(() => {
          store.dispatch(setLoading(false));
          $location.path(store.dispatch(getRedirectUrlPath('step-2')));
        })
        .catch(() => {
          store.dispatch(setLoading(false));

          if (!returnPostTooltipState) {
            store.dispatch(
              setTooltipText(
                language['returns.step_1.return_post_error_tooltip'] ||
                DEFAULT_LANG_COPY['returns.step_1.return_post_error_tooltip'],
              ),
            );
            store.dispatch(toggleTooltip('step1ErrorTooltip'));
          }
        });
    };

    $scope.goToReturnMethods = (giftOrder) => {
      if (retailerSettingsService.getIsSimpleReturnsBasic()) {
        store.dispatch(selectReturnMethod({ selectedMethodKey: MAIL }));
        returnItemsService.updateMethod(MAIL);
        confirmReturnOrder();
      } else {
        nextStep(giftOrder);
      }
    };

    const toggleReturnsSidebar = (item, exchangeIneligible = false) => {
      returnReasonSidebar.actions.initialize(item, !exchangeIneligible ? isExchange : false);
      returnReasonSidebar.setUpdateCallback(
        toggleExchangeSidebar,
        itemSidebarUpdate,
        resetProductCallback,
      );
      returnReasonSidebar.actions.toggle();
    };

    const toggleExchangeSidebar = (item, selectedProduct) => {
      exchangeSidebar.actions.initialize(item, selectedProduct);
      exchangeSidebar.setUpdateCallback(toggleReturnsSidebar, itemSidebarUpdate);
      exchangeSidebar.actions.toggle();
    };

    const resetProductCallback = (itemId) => {
      exchangeSidebar.actions.resetSelectedProduct(itemId);
    };

    const overrideSidebar = ({ item }) => {
      returnReasonSidebar.actions.initialize({ ...item, disabledOverride: true });
      returnReasonSidebar.setUpdateCallback(
        toggleExchangeSidebar,
        itemSidebarUpdate,
        resetProductCallback,
      );
      returnReasonSidebar.actions.toggle();
    };
    const standardItemSidebar = ({ item, orderNumber }) => {
      let itemList = orderService.getItems();

      if (orderNumber) {
        const {
          multiOrders: { orders: additionalOrders = [] },
        } = store.getState();
        const allOrders = [orderService.getOrder(), ...additionalOrders];
        const currentOrder = allOrders.find(
          ({ order_info: { order_number } }) => order_number === orderNumber,
        );
        itemList =
          currentOrder && currentOrder.order_info_items ? currentOrder.order_info_items : [];
      }

      const match = itemList.filter((current) => item.item_id === current.item_id)[0] || null;

      if (productType === 'returns') {
        if (claimsEnabled) {
          renderProductSelectionSidebar({
            itemSidebarUpdate,
            renderCallback: () =>
              store.dispatch({
                type: RECEIVE_CLAIMS_SIDEBAR_INIT,
                data: { sidebarItem: match },
              }),
          });
        } else if (
          isExchange &&
          !item.inventoryNotAvailable &&
          !isEmpty(match.item_eligibilities) &&
          match.item_eligibilities.exchange.is_eligible
        ) {
          exchangeSidebar.actions.initialize(match);
          exchangeSidebar.setUpdateCallback(toggleReturnsSidebar, itemSidebarUpdate);
          // Set the callbacks for the return reason sidebar in case
          // users navigate back to step 1 and have an item selected for return
          returnReasonSidebar.setUpdateCallback(
            toggleExchangeSidebar,
            itemSidebarUpdate,
            resetProductCallback,
          );
          exchangeSidebar.actions.toggle();
        } else {
          returnReasonSidebar.actions.initialize(match, isExchange);
          returnReasonSidebar.setUpdateCallback(
            toggleExchangeSidebar,
            itemSidebarUpdate,
            resetProductCallback,
          );
          returnReasonSidebar.actions.toggle();
        }
      } else {
        repairSidebar.actions.initialize(match);
        repairSidebar.setUpdateCallback(updateRepairSidebar);
        repairSidebar.actions.toggle();
      }
    };

    $scope.blindItemSidebar = (blindItem) => {
      const {
        page: { productType },
      } = store.getState();
      if (productType === 'returns') {
        blindReturnSidebarService.actions.initialize(blindItem);
        blindReturnSidebarService.setUpdateCallback(updateBlindReturns);
        blindReturnSidebarService.actions.toggle();
      } else {
        blindRepairSidebar.actions.initialize(blindItem);
        blindRepairSidebar.setUpdateCallback(updateBlindRepairs);
        blindRepairSidebar.actions.toggle();
      }
    };

    $scope.itemSidebar = ({ item, orderNumber, disabled }) => {
      if (
        retailerSettingsService.getSettings().itemLimit &&
        returnItemsService.getItems().length >= retailerSettingsService.getSettings().itemLimit &&
        !returnItemsService.getItems().find(({ item_id: itemId }) => itemId === item.item_id)
      ) {
        return;
      }

      if ((disabled && !deferOverride) || (deferOverride && !overrideCode && disabled)) return;

      const completedBlindItem = item.blindItem && item.item_id;

      if ((!item.blindItem || completedBlindItem) && !disabled) {
        standardItemSidebar({ item, orderNumber });
      } else if (disabled && deferOverride) {
        overrideSidebar({ item });
      } else {
        $scope.blindItemSidebar(item);
      }
    };

    $scope.onItemsDisclaimerChange = () => {
      store.dispatch(toggleItemsDisclaimerChecked());
      updateSubmitStatus();
    };

    // TODO: Use barcode_url to determine visibility when BE sends it back [RTN-11652]
    $scope.hasPrinterlessLink = (returnMethod) => PRINTERLESS_METHODS.includes(returnMethod);

    // TODO: Use label_url to determine visibility when BE sends it back [RTN-11652]
    $scope.hasReprintLabelLink = (returnMethod) => !METHODS_WITHOUT_PSSLS.includes(returnMethod);

    $scope.getPrinterlessInfoLink = ({ encrypted_return_id: encryptedReturnId }) =>
      getPrinterlessInfoLink({
        retailer,
        encryptedReturnId,
        locale,
      });

    returnStatus();
    checkMaxItemsReached();
  },
]);
